<script setup lang="ts">
import { useEmitter } from "@/composition/useEmitter";
import { useAppStore } from "@/store/app";
import { defineAsyncMicroApp, unmountApp } from "@gohighlevel/ghl-module-federation-plugin";
import { markRaw, onBeforeUnmount, ref, watch } from "vue";

const props = defineProps<{
  show: boolean;
}>();

const emit = defineEmits(["update:close-modal"]);
const appStore = useAppStore();
const emitter = useEmitter();
const remoteComponent = ref<any>(null);
let mounted = false;

const mountRemote = async () => {
  if (mounted) {
    return;
  }
  try {
    const [componentMod] = await defineAsyncMicroApp("quizResultBuilderApp", ["ManageCategoryModal"]);
    remoteComponent.value = markRaw(componentMod);
    mounted = true;
  } catch (error) {
    console.error("Failed to mount ManageCategoryModal remote", error);
  }
};

watch(
  () => props.show,
  (show) => {
    if (show) {
      mountRemote();
    }
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  unmountApp("quizResultBuilderApp");
});
</script>

<template>
  <component
    :is="remoteComponent"
    v-if="show && remoteComponent"
    :show="show"
    :store="appStore"
    :emitter="emitter"
    @update:close-modal="emit('update:close-modal')"
  />
</template>
